import { css } from 'lit';
// language=CSS
export default css`
  :host {
    height: 100%;
  }

  ki-menu-hdoe::part(menu-item) {
    display: flex;
    color: white;
    flex-direction: row;
    margin: 10px 5px;
    background: var(--theme-color-primary, #1d1d1b);
    border: 1px solid var(--theme-color-primary, #1d1d1b);
    align-items: center;
    flex: 1 1 0%;
    position: relative;
    justify-content: start;
    transition: all 0.3s ease 0s;
    min-width: 0%;
    max-height: 100px;
    max-width: 320px;
  }

  ki-menu-hdoe::part(menu-label) {
    padding: 0px 5px 0px 5px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: normal;
    word-break: break-word;
  }

  ki-menu-hdoe::part(sub-menu-item) {
    color: white;
    font-weight: bold;
  }

  ki-menu-hdoe::part(sub-menu-item):hover {
    color: var(--theme-color-primary, #1d1d1b);
  }

  ki-menu-hdoe::part(menu-icon) {
    fill: white;
    border: 0px;
    margin-bottom: 3px;
  }

  ki-menu-hdoe::part(menu-item):hover ki-menu-hdoe::part(menu-icon) {
    fill: var(--theme-color-primary, #1d1d1b);
  }

  ki-menu-hdoe::part(expand-icon) {
    fill: white;
  }

  ki-menu-hdoe::part(menu-item):hover ki-menu-hdoe::part(expand-icon) {
    fill: var(--theme-color-primary, #1d1d1b);
  }

  .header {
    height: 80px;
    background: white;
  }

  .wappenText {
    font-weight: 600;
  }
  .footer {
    display: flex;
    justify-content: space-between;
    border-top: var(
      --ki-breadcrumbs-border-bottom,
      var(--ki-breadcrumbs-border, none)
    );
  }
  .footer .item {
    padding: 3px 5px;
  }
  .footer a {
    padding: 3px 5px;
    text-decoration: none;
    color: var(--theme-text-color, 'rgb(29,29,29)');
  }
  .footer a:hover {
    background: var(--theme-color-secondary, white);
    color: var(--theme-text-color, darkgray);
  }
  .logo-left {
    align-items: center;
  }
  .logo-right {
    width: 165px;
    justify-content: center;
  }

  .footer .mobile {
    display: none;
  }

  :host(.sm-screen) .header {
    height: 50pt;
  }

  :host(.sm-screen) .main {
    border-top: 1px solid lightgray;
  }

  :host(.sm-screen) ki-app-breadcrumb:last-child {
    display: none;
  }

  :host(.sm-screen) .logo-left img,
  :host(.sm-screen) .logo-right img {
    height: 40pt;
    padding: 5px;
  }
  :host(.sm-screen) .logo-right {
    width: auto;
    align-items: center;
    margin-right: 10px;
  }

  :host(.sm-screen) .footer .mobile {
    display: block;
  }
  :host(.sm-screen) .footer .desktop {
    display: none;
  }
`;
